import React from "react";

const FooterBottom = () => {
  return (
    <div className="w-full py-10">
      <p className="text-center text-gray-500 text-base">
        © 2026. All rights reserved by King Jesse Oluwadamilare
      </p>
    </div>
  );
};

export default FooterBottom;
